import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'react-feather';
import { TOOLBOX_ITEMS } from '../elementRegistry';
import { TOOLBOX_DRAG_TYPE, dragState } from '../Canvas/PageCanvas';
import { useAppDispatch, useAppSelector } from '../../../../../ReaduxToolkit/Hooks';
import { setActiveTool } from '../store/formDesignerUiSlice';

const CATEGORIES = ['Basic', 'Media', 'Layout', 'Selection', 'Input'] as const;

// Checkbox/Radio aren't dropped as blank boxes -- click one to arm it, then
// click an existing field on the canvas to attach it as that field's title.
const SELECTION_TOOL_TYPES = new Set(['checkbox', 'radio']);

export default function Toolbox() {
  const dispatch = useAppDispatch();
  const activeTool = useAppSelector((s) => s.FormDesignerUi.activeTool);
  const [collapsed, setCollapsed] = useState<Record<string, boolean>>({});

  return (
    <div className="fd-toolbox">
      {CATEGORIES.map((cat) => (
        <div key={cat} className="fd-toolbox-category">
          <button
            type="button"
            className="fd-toolbox-category-title fd-toolbox-category-toggle"
            aria-expanded={!collapsed[cat]}
            onClick={() => setCollapsed((c) => ({ ...c, [cat]: !c[cat] }))}
          >
            {collapsed[cat] ? <ChevronRight size={12} /> : <ChevronDown size={12} />} {cat}
          </button>
          {!collapsed[cat] && (<>
          <div className="fd-toolbox-items">
            {TOOLBOX_ITEMS.filter((i) => i.category === cat).map((item) =>
              SELECTION_TOOL_TYPES.has(item.type) ? (
                <div
                  key={item.type}
                  className={`fd-toolbox-item fd-toolbox-tool${activeTool === item.type ? ' fd-toolbox-tool-active' : ''}`}
                  title="Click, then click a field on the canvas to attach it here"
                  onClick={() => dispatch(setActiveTool(activeTool === item.type ? null : (item.type as 'checkbox' | 'radio')))}
                >
                  {item.label}
                </div>
              ) : (
                <div
                  key={item.type}
                  className="fd-toolbox-item"
                  draggable
                  onDragStart={(e) => {
                    dragState.toolbox = item.type;
                    e.dataTransfer.setData(TOOLBOX_DRAG_TYPE, item.type);
                    e.dataTransfer.effectAllowed = 'copy';
                  }}
                  onDragEnd={() => { dragState.toolbox = ''; }}
                >
                  {item.label}
                </div>
              )
            )}
          </div>
          {cat === 'Selection' && (
            <div className="fd-toolbox-hint">
              {activeTool
                ? 'Click or drag fields on the canvas to attach them. Click the tool again to stop.'
                : 'Click, then pick fields on the canvas.'}
            </div>
          )}
          </>)}
        </div>
      ))}
    </div>
  );
}
